export const baseUrl = `https://backend.subsidysupportnetwork.org/sites/production?`;

export const localScript = "/scripts/localScript.js";
export const scriptValue = "/scripts/scripts.js";
